<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div class="subcategory">
    <h3 class="scale-2 scale-2--bold-uppercase subcategory__title">
      {{ props.title }}
    </h3>
    <div class="d-none d-640-block">
      <div class="subcategory__grid">
        <SlideImage
          v-for="(item, index) in props.items"
          :key="index"
          :slide="item"
          class="subcategory__item slide__zoom"
        />
      </div>
    </div>
    <div class="d-640-none subcategory__slider">
      <Slider
        class="slider--overflow"
        :show-pagination="true"
        :slides="props.items"
      >
        <template #default="slide">
          <SlideImage
            :slide="slide"
            class="slide__zoom"
          />
        </template>
      </Slider>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.subcategory {
  &__title {
    margin-bottom: 30px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 40px;
    row-gap: 40px;
    margin: 0;

    @include media-breakpoint-down(640) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      row-gap: 20px;
    }
  }

  &__item {
    height: clamp(160px, 3.47vw + 148.89px, 210px);
  }

  &__slider {
    :deep(.embla__slide) {
      height: clamp(160px, 3.47vw + 148.89px, 210px);
    }
    :deep(.embla__slide) {
      flex: 0 0 83.333%; /* Default slide covers 100% of the viewport */
    }
  }
}
</style>
